export class CustomerEnrollment {
  autoPayOptInIndicator: boolean;
  eDeliveryOptInIndicator: boolean;
  onineBillingOptInIndicator: boolean;
  ubiOptInIndicator: boolean;
  ubiDeviceOptInIndicator: boolean;
  managedPreferenceChangeIndicator: boolean;
}
